import React, { useState, useEffect } from 'react';
import { FormInput, FormSubTitle, FormTitle } from '../validation/Form-Components';
import { Form, Field, FormElement } from '@progress/kendo-react-form';
import FormContainer from '../components/FormContainer';
import SubHeader from '../components/SubHeader';
import { requiredValidator } from '../validation/Validators';
import govtService from '../services/GovtApiService';
import stateService from '../services/StateApiService';
import config from '../appconfig/config.json';
import { useHistory } from "react-router-dom";
import Loading from '../components/Loading';
import storage from '../factory/StorageFactory';
import helper from '../factory/Helper';

let state= '',code = '', isFirstTime = true;

const MyInfoLanding = (props) => {

    //nric: S9812388A
    const history = useHistory();
    const [isLoading, setIsLoading] = useState(true);
    
    useEffect(() => {
 
        const queryString = require('query-string');
        const parsed = queryString.parse(props.location.search);
        if(parsed.error !== undefined) {
            //redirect to product url
            if(storage.getIsFirstTime() === 'true') {
                window.location.href = helper.getProductPageUrl(storage.getProductType());
                storage.clearAll();
            }
            else {
                window.location.href = helper.getConsentPageUrl(storage.getRefNo());
                storage.clearAll();
            }
            return;
        }
        
        state = parsed.state;
        code = parsed.code;
        if(storage.getIsFirstTime() !== null) {
            isFirstTime = storage.getIsFirstTime() === 'true'? true:false;
        }
        else {
            isFirstTime = true;
        }
      
        checkServerStatus();
    }, []);

    const checkServerStatus = ( ) => {
        if(config.SERVER_STATUS === 'UAT' || config.SERVER_STATUS === 'PROD') {
            if(isFirstTime) {  
               getMyInfo(code);
            }
            else {
                getPerson(code);
            }
        }
        else { //SIM, DEV 
            setIsLoading(false);
        }
    }

    const handleSubmit = (dataItem) => {
        let data = JSON.parse(JSON.stringify(dataItem));
        let nric = data.nric;
        setIsLoading(true);
        //SIT or DEV
        if(isFirstTime) {  
        
            getMyInfo(nric);
        }
        else {
       
            getPerson(nric);
        }
    } 

    const getPerson = (nric) => {
 
        if(state === '' || code === '') {
            return;
        } 

        govtService.retrievePerson(state, nric).then( res=> {
            let resData = res.data;
            if(resData.statuscode.toUpperCase() === 'OK') {
                validateState();
            }
            else {
                setIsLoading(false);
                goErrorPage();
            }
        }).catch(err => {
         
            setIsLoading(false);
            goErrorPage();
        })
    }

    const getMyInfo = (nric) => {
 
        if(state === '' || code === '') {
            return;
        } 
   
        govtService.retrieveMyInfo(state, nric).then( res=>{
           
            let resData = res.data;
            if(resData.statuscode.toUpperCase() === 'OK') {
                validateState();
            }
            else {
                setIsLoading(false);
                goErrorPage();
            }
        }).catch(err => {
            setIsLoading(false);
            goErrorPage();
        })
    }

    const validateState = () => {
      
        stateService.getStateValidate(state).then( res=> {
      
            let resData = res.data;
            if(resData.isSucess) {
                if(isFirstTime) {
                    history.push(config.route.CompanyDetails+'?state='+state);
                }
                else {
                    history.push(config.route.NSApplicantDetails+'?state='+state);
                }
            }
            else {
                goErrorPage();
            }
            setIsLoading(false);
        }).catch(err =>{
          
            setIsLoading(false);
            goErrorPage();
        })
    }
 

    const goErrorPage = () => {
        history.push(config.route.MyInfoError);
    }

    if(isLoading) {
        return(
            <Loading />
        )
    }

    return (
     <div className="container-fluid">
               <SubHeader />
               <Form onSubmit={handleSubmit} 
                render={(formRenderProps)=> (
                    <FormElement>
                        <FormContainer>
                            <fieldset>
                                <Field component={FormTitle} 
                                    id={'ftitle'} 
                                    name={'Maybank online application'} />
                                <Field component={FormSubTitle} id={'fstST1'} 
                                    name={'Enter NRIC to apply via MyInfo'} />
                                
                                <div className="row around-xs inputPair elementVisible">
                                    <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                                        <div className="box">
                                            <Field name={'nric'} placeholder={'Please input'} 
                                            component={FormInput} 
                                            validator={requiredValidator} />
                                        </div>
                                    </div>
                                </div>
                                <div className="row around-xs inputPair elementVisible" style={{ marginTop: "1rem" }}>
                                    <div  className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                                        <div className="text-center">
                                        <div className="box">
                                            <button type={'submit'} className="k-button btn btn-success btn-float-right" >Confirm</button>
                                        </div>
                                        </div>
                                    </div>
                                </div> 
                       
                            </fieldset>
                          
                        </FormContainer>
                    </FormElement>
                )}>
               </Form>
        </div>
 
    )
}

export default MyInfoLanding